import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreAppsFieldsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-apps-fields',
	path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
	exact: true,
};
